import { Helmet } from 'react-helmet';
import BannerImage from '../components/BannerImage';
import Button from '../components/Button';
import WhoWeAreTiles from '../components/WhoWeAreTiles';
import S3CLink from '../components/S3CLink';
import styles from '../styles/WhoWeAre.module.scss';
import tile1Img from '../assets/images/tile-images/who-we-are-tile-1.png';
import accentureLogo from '../assets/images/tile-images/Accenture_logo.png';
import rabinMartinLogo from '../assets/images/tile-images/RabinMartin-logo.png';
import mfmLogo from '../assets/images/logos/msd-for-mothers-logo.png';
import { whoWeAreBannerData } from '../utils/bannerData/bannerData.js';
import VideoTile from '../components/VideoTile';

const WhoWeAre = () => {
  return (
    <>
      <Helmet>
        <title>Who We Are | Strengthening Systems for Safer Childbirth</title>
      </Helmet>
      <BannerImage data={whoWeAreBannerData} />
      <div className={styles.whiteCopySection}>
        <strong>Strenghtening Systems for Safer Childbirth</strong> responds to
        the urgent need to pick up the pace in saving women’s lives and meet the
        Sustainable Development Goals for reducing maternal mortality. We
        believe that communities know best what’s needed to make the difference
        and that solutions are strongest when we can work across silos and
        sectors. Our goal is to strengthen locally-led, multi-sector coalitions,
        enabling them to implement solutions that will improve access to
        high-quality, respectful maternal health — for lasting impact.
      </div>

      <WhoWeAreTiles tileColor='blue' image={tile1Img} imgSide='left' titleLine>
        <h2>A Focused Approach</h2>
        <p>
          Coalition members are organizations that span sectors and disciplines
          – from private health care providers to community-based organizations
          to local entrepreneurs who bring innovation to service delivery.
          Working collectively, these organizations will design solutions based
          on the needs and preferences of women in their communities, striving
          to achieve sustained measurable improvements in maternal health.
        </p>
      </WhoWeAreTiles>

      <WhoWeAreTiles tileColor='white' image={mfmLogo} imgSide='left' logoTile>
        <h2>Powered by MSD for Mothers</h2>
        <p>
          MSD for Mothers is MSD’s global initiative to help create a world
          where no woman has to die while giving life. MSD for Mothers works
          with grantees and collaborators to improve the health and well-being
          of women during pregnancy, childbirth and the months after. MSD for
          Mothers is an initiative of Merck & Co., Inc.,
          Rahway,&nbsp;NJ,&nbsp;USA.
        </p>
        <S3CLink href='http://www.msdformothers.com'>
          <Button variant={'primary'}>LEARN MORE</Button>
        </S3CLink>
      </WhoWeAreTiles>
      {/* <WhoWeAreTiles
        tileColor='blue'
        image={tile2Img}
        imgSide='right'
        titleLine
        narrowText
      >
        <h2>Our Coalitions</h2>
        <p>
          Strengthening Systems for Safer Childbirth supports six locally-led
          coalitions across India, Kenya, Nigeria and Sierra Leone aimed at
          improving maternal health care in their communities.
        </p>
        <S3CLink href='/where-we-work' internal>
          <Button variant={'primaryWhiteColor'}>LEARN MORE</Button>
        </S3CLink>
      </WhoWeAreTiles> */}
      <div className={styles.blueSection}>
        <div className={styles.blueCopySection}>
        <h2>Our Coalitions</h2>
          <p>
            Strengthening Systems for Safer Childbirth supports six locally-led
            coalitions across India, Kenya, Nigeria and Sierra Leone aimed at
            improving maternal health care in their communities.
          </p>

          <div className={styles.wwdTilesSection}>
            <VideoTile
              heading='India'
            >
             
            <p><a href="/where-we-work#e-saathi">e-SAATHI</a></p>
            
            </VideoTile>
            <div className={styles.wwdTilesDivider} />
            <VideoTile
              heading='Kenya'
            >
              <p><a href="/where-we-work#mamalink">MamaLink</a><br/>
              <a href="/where-we-work#kenya-quality-ecosystem">Kenya Quality Ecosystem</a></p>

            </VideoTile>
            <div className={styles.wwdTilesDivider} />
            <VideoTile
              heading='Nigeria'
            >
              <p><a href="/where-we-work#financing">FOR M(om)</a><br/>
              <a href="/where-we-work#project-aisha">Project Aisha</a></p>
            
            </VideoTile>
            <div className={styles.wwdTilesDivider} />
            <VideoTile
              heading='Sierra Leone'
            >
             <p><a href="/where-we-work#wellbody">Wellbody</a></p>
            
            </VideoTile>
          </div>


          <div className="d-flex justify-content-center">
            <S3CLink href="/where-we-work" internal>
              <Button variant="primaryWhiteColor">LEARN MORE</Button>
            </S3CLink>
          </div>

          

        </div>

      </div>
      
      <div className={styles.whiteCopySection}>
          <h2>Governance Team</h2>
          <h3>Coalitions are supported and guided by a governance team to achieve their goals.</h3>
          <div className={styles.wwdTilesSection}>
            <VideoTile
              heading='Community of Practice'
            >
            <img 
              src={accentureLogo} 
              alt="Community of Practice" 
              style={{ maxWidth: '200px', height: 'auto', marginBottom: '2rem' }} 
            />

            <p><strong>The Strengthening Systems for Safer Childbirth Community of Practice, facilitated by Accenture Development Partnerships</strong>, brings the coalitions together to share experiences, problem-solve collectively, deliver on intended results, demonstrate impact, achieve sustainability and amplify their learnings. The CoP was launched as a bold experiment to break down silos in maternal health and advance collaboration for collective impact. Serving as a dynamic platform, the CoP enables coalitions to exchange programmatic insights and learnings, tackle shared challenges, and amplify advocacy initiatives.</p>
            
            </VideoTile>
            <div className={styles.purpleTilesDivider} />
            <VideoTile
              heading='Secretariat'
            >
              <img 
              src={rabinMartinLogo} 
              alt="Community of Practice" 
              style={{ maxWidth: '200px', height: 'auto', marginBottom: '2rem' }} 
            />
              <p><strong>Rabin Martin, a team of global health impact advisors, serves as the secretariat of the initiative</strong> and provides strategic guidance and technical support to the six coalitions. The secretariat oversees coalition progress towards their implementation and advocacy goals and manages the evaluation of the initiative. By capturing the impact of the coalitions on their communities and health systems, the secretariat is elevating the work of the coalitions on the global stage.</p>

            </VideoTile>
            
          </div>
      </div>
    </>
  );
};

export default WhoWeAre;
